export function matchEntityListItems<
  TPayload extends { id: string },
  TLive,
>(
  payloadItems: TPayload[] | undefined,
  liveById: ReadonlyMap<string, TLive>
): Array<{ payload: TPayload; live: TLive | undefined }> {
  return (payloadItems ?? []).map((payload) => ({
    payload,
    live: liveById.get(payload.id),
  }));
}
